"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { trackScrollDepth } from "@/lib/metrics";

const DEPTHS = [25, 50, 75, 100];

/** Scroll depth tracking for landing pages, deduplicated per page view. */
export function ScrollDepthTracker() {
  const pathname = usePathname();
  const sentDepths = useRef(new Set<number>());

  useEffect(() => {
    sentDepths.current.clear();

    const onScroll = () => {
      const h = document.documentElement;
      const scrollableHeight = h.scrollHeight - h.clientHeight;
      if (scrollableHeight <= 0) return;

      const pct = Math.round((h.scrollTop / scrollableHeight) * 100);
      for (const d of DEPTHS) {
        if (pct >= d && !sentDepths.current.has(d)) {
          sentDepths.current.add(d);
          trackScrollDepth(d);
        }
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  return null;
}
